import { createContext, useContext } from 'react'
import type { PreparedLocationHit } from '../types'

type TDataContext = {
  items: PreparedLocationHit[]
}

const DataContext = createContext<TDataContext>({
  items: []
})

export const DataProvider = ({
  items,
  children
}: {
  items: PreparedLocationHit[]
  children: React.ReactNode
}) => {
  return (
    <DataContext.Provider value={{ items }}>{children}</DataContext.Provider>
  )
}

export const useHits = () => {
  return useContext(DataContext)
}
